/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React, { SVGTextElementAttributes } from 'react';

interface ISVGCenterTextProps {
  xDomain?: number[];
  yDomain?: number[];
  padding?: number;
  text: string;
  textAttrs?: SVGTextElementAttributes<SVGTextElement>;
}

export function SVGCenterText(props: ISVGCenterTextProps): React.ReactElement {
  const textRef = React.useRef<SVGTextElement>(null);
  const [x, setX] = React.useState(0);
  const [y, setY] = React.useState(0);
  const [opacity, setOpacity] = React.useState(0);
  const [text, setText] = React.useState(props.text);

  const setAll = (x: number, y: number, text: string): void => {
    setX(x);
    setY(y);
    setText(text);
  };

  React.useEffect((): void => {
    if (textRef.current) {
      const leftPadding = props.padding ?? 0;
      // Get the width of the text using getBBox()
      const { height, width } = textRef.current.getBBox();
      let newX = props.textAttrs?.x ?? 0;
      let newY = props.textAttrs?.y ?? 0;
      let text = props.text;
      let overflow = false;
      if (props.xDomain) {
        const xWidth = props.xDomain[1] - props.xDomain[0] - leftPadding;
        if (width > xWidth) {
          overflow = true;
        }
        // Calculate the new x position
        newX =
          (xWidth - leftPadding) / 2 -
          width / 2 +
          props.xDomain[0] +
          leftPadding;
      }
      if (props.yDomain) {
        const yHeight = props.yDomain[1] - props.yDomain[0];
        const midpoint = yHeight / 2 + props.yDomain[0];
        newY = midpoint - height / 3;
      }
      if (overflow) {
        text = `${props.text.slice(0, 18)}...`;
      }
      setAll(+newX > 0 ? +newX : 0, +newY > 0 ? +newY : 0, text);
      setTimeout((): void => {
        setOpacity(
          props.textAttrs?.opacity !== undefined ? +props.textAttrs?.opacity : 1
        );
      }, 100);
    }
  }, [
    props.text,
    JSON.stringify(props.xDomain),
    JSON.stringify(props.yDomain),
  ]);

  return (
    <React.Fragment>
      <text
        {...props.textAttrs}
        x={props.xDomain ? x : props.textAttrs?.x ?? 0}
        y={props.yDomain ? y : props.textAttrs?.y ?? 0}
        opacity={opacity}
        ref={textRef}
        dominantBaseline='hanging'
      >
        {text}
      </text>
    </React.Fragment>
  );
}
